import React, { useEffect, useState, useCallback } from "react";
import {
  Col,
  Row,
  Card,
  CardBody,
  Button,
  InputGroup,
  Input,
  ButtonGroup,
  Table,
} from "reactstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Triangle } from "react-loader-spinner";
import toast from "react-hot-toast";
import CustomDataTable from "../../../Components/CustomTable/CustomTable";
import BreadCrumb from "../../../Components/Common/BreadCrumb";

import {
  formatDate,
  formatDateTimes,
} from "../../../Components/Common/FormatDate";
import Select from "react-select";
import CustomerServices from "../../../services/OrderingServices/CustomerServices";
import CreditLogService from "../../../services/OrderingServices/CreditLogService";
import CreditPayModal from "../component/CreditPayModal";
import NumberWithCommas from "../../../pages/Pages/Starter/NumberWithCommas";
const customStyles = {
  headCells: {
    style: {
      fontSize: "0.92rem",
      fontWeight: 610,
    },
  },
  rows: {
    style: {
      fontSize: "0.9rem",
    },
  },
};

const CreditLog = () => {
  const { id } = useParams();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [remarks, setRemarks] = useState();
  const [touched, setTouched] = useState();
  const isInvalid = touched && !remarks?.trim();
  const [isOpen, setIsOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState();
  console.log("🚀 ~ CreditLog ~ selectedItem:", selectedItem);
  const [selectedCustomer, setSelectedCustomer] = useState();
  const navigate = useNavigate();
  const toggleModal = (row) => {
    setIsOpen(!isOpen);
    setSelectedItem(row);
  };

  const [customerList, setCustomerList] = useState([]);
  const fetchCustomers = async () => {
    try {
      setLoading(true);
      const response = await CustomerServices.getCustomerList();

      const transformed = response.map((cust) => ({
        value: cust.id,
        label: `${cust.firstName} ${cust.lastName}`,
        ...cust,
      }));

      setCustomerList(transformed);

      // If we have id from params, select the corresponding customer
      if (id) {
        const selected = transformed.find((cust) => cust.id === parseInt(id));
        if (selected) setSelectedCustomer(selected);
      }

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("🚀 ~ error:", error);
    }
  };

  // Fetch customers when debounced filters, current page or page size changes
  useEffect(() => {
    fetchCustomers();
  }, []);
  const fetchCreditLogs = async (customerId) => {
    try {
      setLoading(true);
      const response = await CreditLogService.getList(customerId);
      setData(response);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("🚀 ~ error:", error);
    }
  };

  // Fetch customers when debounced filters, current page or page size changes
  useEffect(() => {
    if (selectedCustomer) {
      fetchCreditLogs(selectedCustomer.id);
    }
  }, [selectedCustomer]);

  const [filterText, setFilterText] = useState("");

  const handleFilterChange = (e) => {
    setFilterText(e.target.value);
  };

  const filteredData = data.filter((pkg) => {
    // console.log("🚀 ~ filteredPackages ~ pkg:", pkg);

    // Combine name, surname, email, and phone number into a single search context, handling undefined fields
    const searchContext = `${pkg?.orderId || ""}`.toLowerCase();

    // Check if the filterText is included in any of the search context
    const matchesFilter = searchContext.includes(filterText.toLowerCase());

    return matchesFilter;
  });
  const handleCustomerChange = (selectedOption) => {
    setSelectedCustomer(selectedOption);
  };
  const breadcrumbItems = [
    { title: "Back To List", onClick: () => navigate(-1) },
  ];
  console.log("🚀 ~ CreditLog ~ filteredData:", filteredData);
  return (
    <div className="page-content">
      <div className="container-fluid">
        <BreadCrumb
          title="Credit Logs List"
          pageTitle="Credit log of customer"
          breadcrumbItems={breadcrumbItems}
        />
      </div>
      <Row>
        {/* <Col md={8} xs={12} className="mb-2">
          <InputGroup>
            <Input
              placeholder="Search by order id"
              value={filterText}
              onChange={handleFilterChange}
            />
          </InputGroup>
        </Col> */}
        <Col xs={12} lg={3} className="mb-2">
          <Select
            options={customerList}
            value={selectedCustomer}
            onChange={handleCustomerChange}
            placeholder="Select customer"
            isClearable
            menuPortalTarget={document.body}
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            }}
          />
        </Col>
      </Row>
      <Card>
        <CardBody>
          <Row>
            {selectedCustomer && (
              <div className="d-flex justify-content-between align-content-center align-items-center">
                {filteredData.length > 0 && (
                  <h5>
                    Balanced Amount:{" "}
                    <strong> <NumberWithCommas number={filteredData[0].remainingAmount} /></strong>
                  </h5>
                )}
                <div className="d-flex justify-content-end mb-3">
                  <button
                    className="btn  btn-success"
                    onClick={() => toggleModal()}
                  >
                    Credit Payment
                  </button>
                </div>
              </div>
            )}
            {selectedCustomer ? (
              <div className="table-responsive">
                <Table bordered hover className="mb-0 table-nowrap ">
                  <thead className="bg-light">
                    <tr>
                      <th style={{ width: "60px" }}>S.N</th>
                      <th>Reference No</th>
                      {/* <th style={{ width: "130px" }}>Date</th> */}
                      <th style={{ width: "20vw" }}>Remarks</th>
                      <th className="text-end">Debit</th>
                      <th className="text-end">Credit</th>
                      <th className="text-end">Balanced Amt</th>

                      <th style={{ width: "9vw" }}>Created By</th>
                      {/* <th style={{ width: "80px" }}>Action</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {filteredData.length > 0 ? (
                      filteredData.map((item, index) => (
                        <tr key={item.id || index}>
                          <td className="fs-6">{index + 1}</td>
                          {/* <td className="fs-6 d-flex flex-column">
                            <Link to={`/order/${item?.orderId}`}>
                              {item.orderRefrenceId}
                            </Link>
                            {formatDateTimes(item.createdDate)}
                          </td> */}
                          <td className="fs-6 d-flex flex-column">
                            {item.orderRefrenceId?.startsWith("ORD") ? (
                              <Link to={`/order/${item?.orderRefrenceId}`}>
                                {item.orderRefrenceId}
                              </Link>
                            ) : (
                              <span>{item.orderRefrenceId}</span>
                            )}
                            {formatDateTimes(item.createdDate)}
                          </td>

                          <td
                            className="fs-6 "
                            style={{
                              overflow: "hidden",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {item.remarks}
                          </td>
                          <td className="text-end fs-6 text-success">
                            {item.paidAmount > 0 ? (
                              <NumberWithCommas number={item.paidAmount} />
                            ) : (
                              "-"
                            )}
                          </td>
                          <td className="text-end fs-6 text-danger">
                            {item.creditAmount > 0 ? (
                              <NumberWithCommas number={item.creditAmount} />
                            ) : (
                              "-"
                            )}
                          </td>
                          <td className="text-end fs-6 fw-bold">
                            {item.remainingAmount !== null &&
                            item.remainingAmount !== undefined &&
                            item.remainingAmount !== 0 ? (
                              <NumberWithCommas number={item.remainingAmount} />
                            ) : (
                              "-"
                            )}
                          </td>

                          <td className="fs-6" title={item.createdBy}>
                            {item.createdBy?.length > 10
                              ? item.createdBy.substring(0, 10) + "..."
                              : item.createdBy}
                          </td>
                          {/* <td>
                            <button
                              className="btn btn-sm btn-success"
                              onClick={() => toggleModal(item)}
                            >
                              Pay
                            </button>
                          </td> */}
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="7" className="text-center">
                          No credit by customer
                        </td>
                      </tr>
                    )}
                  </tbody>
                  {/* <tfoot className="font-weight-bold">
                    <tr>
                      <td colSpan="4" className="text-end fw-bold">
                        Total
                      </td>
                      <td className="text-end fw-bold text-success">
                        <NumberWithCommas
                          number={filteredData
                            .filter((t) => t.paidAmount > 0)
                            .reduce((sum, t) => sum + t.paidAmount, 0)}
                        />
                      </td>
                      <td className="text-end fw-bold text-danger">
                        <NumberWithCommas
                          number={filteredData
                            .filter((t) => t.creditAmount > 0)
                            .reduce((sum, t) => sum + t.creditAmount, 0)}
                        />
                      </td>

                      <td></td>
                    </tr>
                  </tfoot> */}
                </Table>
              </div>
            ) : (
              <div className="text-center py-3">
                <p className="text-muted mb-0">No payment records found.</p>
                <p className="text-muted">
                  {" "}
                  Selected customer to get payment records
                </p>
              </div>
            )}
          </Row>
        </CardBody>
      </Card>

      {/* <Card>
        <CardBody>
          <CustomDataTable
            responsive
            striped
            pagination
            fixedHeader
            persistTableHead
            progressPending={loading}
            customStyles={customStyles}
            progressComponent={
              <div className="my-3">
                <Triangle
                  visible={true}
                  height="80"
                  width="80"
                  color="#5B71B9"
                  ariaLabel="triangle-loading"
                />
                <h5 className="mt-1">Loading...</h5>
              </div>
            }
            columns={columns}
            data={filteredData}
          />
        </CardBody>
      </Card> */}
      <CreditPayModal
        isOpen={isOpen}
        toggle={toggleModal}
        fetchCreditLogs={fetchCreditLogs}
        selectedItem={selectedItem}
        selectedCustomer={selectedCustomer}
      />
    </div>
  );
};

export default CreditLog;
